import { Theme, makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export default makeStyles<Theme>({
  root: {
    minHeight: 560,
    width: 850,
    backgroundColor: '#fff',
    borderRadius: 12,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)'
    }
  },
  paragraphQuestion: {
    borderRadius: '12px 12px 0 0',
    backgroundColor: '#1E5593',
    minHeight: 220,
    display: 'flex',
    alignItems: 'center'
  }
})
